export default __webpack_public_path__ + "static/media/hus_3.50cac24b.svg";